import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { AppBarLayout, Breadcrumbs } from 'commons-ui';

import { ACL_ENTITIES, Entity, GAME_ADMIN_RESOURCES, PAGE_NAMES } from 'constant';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';

import GameAdminHome from './GameAdminHome';
import { URL, COMPONENT } from './helper';

const GameAdmin: React.FC<{}> = () => {
	return (
		<>
			<AppBarLayout />
			<Breadcrumbs />
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={PAGE_NAMES.gameAdmin}
					path={`/${PAGE_NAMES.gameAdmin}`}
					component={GameAdminHome}
				/>
				{_map(_values(GAME_ADMIN_RESOURCES), (entity: Entity) => {
					if (ACL_ENTITIES.includes(entity)) {
						return (
							<AuthorizedRouteV2
								key={entity}
								configPageName={PAGE_NAMES.gameAdmin}
								configResourceName={entity}
								path={URL[entity]}
								component={COMPONENT[entity]}
							/>
						);
					}
					return (
						<AuthorizedRoute
							key={entity}
							configPageName={PAGE_NAMES.gameAdmin}
							entity={entity}
							path={URL[entity]}
							component={COMPONENT[entity]}
						/>
					);
				})}
				<Redirect to={`/${PAGE_NAMES.gameAdmin}`} />
			</Switch>
		</>
	);
};

export default GameAdmin;
